"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberRoleFilter = void 0;
const react_1 = __importStar(require("react"));
const ui_1 = require("../ui");
const MEMBER_FILTER_OPTION = [
    { id: 'all', value: '전체' },
    // { id: '01', value: '강사' },
    { id: '02', value: '조교' },
    { id: '03', value: '학생' },
    // { id: '04', value: '관리자' },
];
exports.MemberRoleFilter = react_1.default.memo(({ isModify, defaultValues, handlerUpdateState, }) => {
    const [values, setValues] = react_1.default.useState(defaultValues);
    (0, react_1.useEffect)(() => {
        handlerUpdateState(values);
    }, [values]);
    return (react_1.default.createElement(ui_1.CheckboxInput, { inputType: "radio", noShowButtonArea: !isModify, defaultValues: defaultValues, handlerUpdate: setValues, options: MEMBER_FILTER_OPTION }));
});
